import React, { useId, useState } from 'react';
import { GOLD_USD_INTRO, REGIME_ROWS } from '../utils/goldUsdSignal';

function GoldUsdHelp() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="gold-usd-help">
      <button
        type="button"
        className="gold-usd-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="gold-usd-help-panel" role="region" aria-label="Gold vs USD guide">
          <p className="gold-usd-help-body">{GOLD_USD_INTRO}</p>
          <table className="gold-usd-regime-table">
            <thead>
              <tr>
                <th>90d correlation</th>
                <th>Regime</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              {REGIME_ROWS.map((row) => (
                <tr key={row.id}>
                  <td>{row.range}</td>
                  <td>
                    {row.emoji} {row.label}
                  </td>
                  <td>{row.tooltip}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="gold-usd-help-note">
            USD leg: DXY when available; otherwise −Δ EUR/USD proxy (~58% of DXY — labeled on chart).
            Positive gold–USD correlation for four or more weeks is a stress signal. Cross-read with
            BTC–Nasdaq below: high beta + stress haven = fragile; low beta + stress = rare alt-haven.
          </p>
        </div>
      )}
    </div>
  );
}

export default GoldUsdHelp;
